var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("validation-provider", {
    class: [{ disabled: _vm.disabled }, "checkbox-container"],
    attrs: { rules: _vm.validationRules },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c("input", {
              ref: "checkbox",
              staticClass: "checkbox",
              attrs: {
                id: _vm.id,
                name: _vm.id,
                type: "checkbox",
                disabled: _vm.disabled,
              },
              domProps: { checked: _vm.value },
              on: { change: _vm.updateCheckboxValue },
            }),
            _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    typeof _vm.labelText === "string"
                      ? _vm.labelText
                      : _vm.$t(_vm.labelText)
                  )
                ),
              ]),
            ]),
            errors
              ? _c("div", { staticClass: "alert-container" }, [
                  _c("span", { staticClass: "alert-text" }, [
                    _vm._v(_vm._s(errors[0])),
                  ]),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }